import type { FC } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@mui/material';

import useFollowUpActionTable from '../components/FollowUpActionTable/FollowUpActionTableContext';

export const FollowUpActionDownloadButton: FC = () => {
  const { t } = useTranslation('common');
  const { downloadAll } = useFollowUpActionTable();

  return <Button onClick={downloadAll}>{t('download')}</Button>;
};
export default FollowUpActionDownloadButton;
